module.exports = __webpack_public_path__ + "img/center-info-structure5-1.ccfa6eef.png";